<template>
  <div
    class="avatarSection business d-flex flex-md-row flex-column align-center"
    v-if="courseDetail.id"
  >
    <div class="editAvatarWrapper">
      <AvatarComponent
        size="175"
        hasBorder
        :url="picture"
        :contain="true"
      />
      <v-btn
        v-if="isEdit"
        elevation="2" icon class="avatar-input"
        @click="$refs.fileInput.click()"
      >
        <v-icon>far fa-camera</v-icon>
      </v-btn>
    </div>
    <input
      v-show="false"
      ref="fileInput"
      type="file"
      name="image"
      accept="image/*"
      @change="onChange"
    />
    <InputCrop
      title="Avatar Uploader"
      :file="fileUpload"
      ref="AvatarUploader"
      @cropped="onCropped"
    />
    <div
      class="boxedContent text-center text-md-left mt-md-7 mb-md-3 ml-0 ml-md-3 col-md-6"
    >
      <h1 class="black--text titleBusinessGolf font-weight-bold">{{ courseDetail.name }}</h1>
      <div
        class="d-flex mt-3 align-center justify-md-start justify-center"
        v-if="!isEdit && token"
      >
        <p class="grey--text mb-0 font-italic subtitle">
          <translate
            :translate-params="{ name: courseDetail.name }">
            Are you a team member of %{name}? Claim this page to manage it.
          </translate>
          <v-btn
            small
            color="primary"
            rounded
            @click="isShowPopup = true"
            :disabled="isHideClaim || disableClaim"
            class="ml-1"
          >
            <translate> Claim </translate>
          </v-btn>
        </p>
      </div>
    </div>
    <span class="ml-md-auto mt-8 d-flex justity-end flex-column">
      <v-btn
        v-if="isFollow"
        class="ml-2 mb-3 text-none"
        color="#E0E0E0"
        elevation="0"
        @click="setUnfollow()"
      >
        <translate :key="isFollow">Unfollow</translate>
      </v-btn>
      <v-btn
        v-else
        :large="$vuetify.breakpoint.md"
        @click="setFollow()"
        depressed
        color="primary"
        class="ml-2 mb-3 text-none font-weight-bold subtitle-md-1 subtitle-2"
      >
        <v-icon size="18" class="mr-2">fal fa-plus</v-icon>
        <translate :key="isFollow">Follow</translate>
      </v-btn>

      <RowIconSocial
        :data="courseDetail"
        justify="justify-end"
      >
      </RowIconSocial>
    </span>
    <DialogConfirmClaim v-model="isShowPopup" @action="success" />
  </div>
</template>
<script>
import RowIconSocial from "@/components/RowIconSocial";
import DialogConfirmClaim from "@/components/Dialog/DialogConfirmClaim";
import InputCrop from "@/components/Forms/InputCrop";
export default {
  name: "AvatarBusiness",
  props: {
    courseDetail: {
      picture: null
    },
    isEdit: { type: Boolean, default: false },
    waitLoading: { type: Boolean, default: false },
  },
  components: {
    InputCrop,
    RowIconSocial,
    DialogConfirmClaim,
  },
  data: () => {
    return {
      isFollow: false,
      isShowPopup: false,
      disableClaim: false,
      fileUpload: null
    }
  },
  watch: {
    courseDetail: {
      immediate: true,
      handler(val) {
        this.isFollow = val.isFollowed || false;
      },
    },
  },
  computed: {
    user() {
      return this.$store.state.auth.user;
    },
    token() {
      return this.$store.state.auth.token;
    },
    courseDetails() {
      return this.$store.state.golfcourse.courseDetail || {};
    },
    isHideClaim() {
      let course = this.courseDetails || {};
      if (!this.token) return true;
      let courseRole = course.courseRole || [];
      if (courseRole.length) {
        let hide =
          courseRole.findIndex(
            (r) =>
              r === "Course Admin" ||
              r === "Request Pending"
          ) !== -1;
        if (hide) return true;
      }
      return false;
    },
    picture() {
      return this.pictureUrl(this.courseDetail.picture)
    }
  },
  methods: {
    async setFollow() {
      if (!this.token) {
        const toggle = await this.$store.state.toggle.dialogConfirm.open(
          this.$gettext("Warning"),
          this.$gettext('You need to login'),
          { color: "warning" }
        );
        if (!toggle) return
        this.$router.push({name: 'login'})
      }

      if (this.user.id) {
        const result = await this.$store.dispatch(
          "follow/setFollow",
          this.courseDetail
        );
        if (result.error) {
          this.$toast.alert(result.error.message);
        } else {
          this.isFollow = true;
          this.$store.dispatch("setTotalFollowing", +1); //set +/- Following
        }
      } else {
        this.$router.push({ name: "login" });
      }
    },
    async setUnfollow() {
      const input = {
        entityId: this.courseDetail.id,
        entityName: this.courseDetail.address ? "course" : "user",
      };
      const result = await this.$store.dispatch("follow/setUnFollow", input);
      if (result.error) {
        this.$toast.alert(result.error.message);
      } else {
        this.isFollow = false;
        this.$store.dispatch("setTotalFollowing", -1); //set +/- Following
      }
    },
    success(val) {
      if (val == true) {
        this.disableClaim = true;
      }
      this.isShowPopup = false;
    },
    onChange(e) {
      let vm = this;
      let files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;

      let reader = new FileReader();
      reader.readAsDataURL(files[0]);
      reader.onload = (e) => {
        vm.fileUpload = e.target.result; // change data image
        vm.$refs.AvatarUploader.open(true); // show popup
      };
    },
    async onCropped(file) {
      let convert = file.replace("data:image/png;base64,", "");
      let result = await this.$store.dispatch("updateAvatarCourse", convert);
      if (result.error) {
        this.$toast.alert(`${result.error.message}`);
      } else {
        this.$nextTick(() => {
          this.courseDetail.picture = result.picture;
        });
      }
    },
  },
};
</script>
